export const GET_FAMILY_SUCCESS = "GET_FAMILY_SUCCESS";
export const GET_FAMILY_LOAD = "GET_FAMILY_LOAD";
export const GET_FAMILY_FAILD = "GET_FAMILY_FAILD";
export const GET_ONE_FAMILY = "GET_ONE_FAMILY";
